import { CardIsa } from './card-isa'
import { CardAllowance } from './card-allowance'
import { CardDefault } from './card-default'

export const PanelDetails = {
  CardIsa,
  CardAllowance,
  CardDefault
}
